import usePrivateAxios from '@/common/api/usePrivateAxios'
import { useMutation } from '@tanstack/react-query'
import { AxiosError } from 'axios'

interface UseReprocessTmaisNfceProps {
  id?: string
  onSuccess?: () => void
  onError?: (error: AxiosError) => void
}

export const useReprocessTmaisNfce = ({ id, onSuccess, onError }: UseReprocessTmaisNfceProps) => {
  const privateAxios = usePrivateAxios()
  return useMutation<void, AxiosError>({
    mutationKey: ['reprocessTmaisNfce', id],
    mutationFn: async () => {
      await privateAxios.post(`/tmais/nfces/${id}/reprocess`)
    },
    onSuccess,
    onError,
  })
}
